/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const prevBtnCss = css`
  ${labellessButtonCss};
  span {
    margin-left: 5px;
  }
`;

const PrevButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "table.row.previous" })}
      iconName="arrow_back_ios"
      css={prevBtnCss}
      {...props}
      dataCy="previous-button"
    />
  );
};

export default PrevButton;
